import {
  DialogClose,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Button,
  toast,
} from '@qodo/design-system';
import { useCancelSubscriptionMutation } from 'network/mutations';
import { spawn } from 'utils/translations';
import { CancelSubscriptionDialogProps } from './types';

const spawnDialog = spawn('dialogs.cancel-subscription');
const spawnDialogActions = spawn('dialogs.cancel-subscription.action');

/**
 * Confirmation dialog for scheduling a self-serve subscription to cancel at
 * the end of the current billing period. On success the billing caches are
 * refreshed by the mutation so the UI reflects the scheduled-to-cancel state.
 */
export const CancelSubscriptionDialog = (
  props: CancelSubscriptionDialogProps,
) => {
  const { onOpenChange = () => {} } = props;
  const { mutate: cancelSubscription } = useCancelSubscriptionMutation();

  const onSubmit = () => {
    onOpenChange(false);
    cancelSubscription(undefined, {
      onSuccess: () => toast.success(spawnDialogActions('success')),
      onError: () => toast.error(spawnDialogActions('error')),
    });
  };

  return (
    <Dialog {...props}>
      <DialogContent autoFocus={false} className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="text-h3">{spawnDialog('title')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{spawnDialog('description')}</DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{spawnDialogActions('cancel')}</Button>
          </DialogClose>
          <Button variant="danger" onClick={onSubmit}>
            {spawnDialogActions('confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
